import { Menu, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { ArrowLink } from './ArrowLink'

const navItems = [
  { href: '/solutions', label: 'Solutions' },
  { href: '/expertise', label: 'Expertise' },
  { href: '/approach', label: 'Approach' },
  { href: '/about', label: 'About' },
]

export function Header() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  return (
    <header className="site-header">
      <a className="brand-link" href="/" aria-label="Informat Limited home">
        <img src="/assets/logo-color.svg" alt="informat" />
      </a>
      <nav className="desktop-nav" aria-label="Primary navigation">
        {navItems.map((item) => (
          <NavLink
            to={item.href}
            key={item.href}
            className={({ isActive }) => (isActive ? 'active' : undefined)}
            onClick={() => setOpen(false)}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="header-actions">
        <ArrowLink
          className="header-cta header-cta--portal"
          href="https://portal.informat.ie/"
          variant="button"
        >
          Client Portal
        </ArrowLink>
        <ArrowLink className="header-cta" href="/contact" variant="button">
          Discuss a project
        </ArrowLink>
      </div>
      <button
        type="button"
        className="menu-toggle"
        aria-label={open ? 'Close navigation' : 'Open navigation'}
        aria-expanded={open}
        aria-controls="mobile-navigation"
        onClick={() => setOpen((current) => !current)}
      >
        {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
      </button>
      <nav
        id="mobile-navigation"
        className="mobile-nav"
        aria-label="Mobile navigation"
        data-open={open}
      >
        {navItems.map((item) => (
          <NavLink
            to={item.href}
            key={item.href}
            className={({ isActive }) => (isActive ? 'active' : undefined)}
          >
            {item.label}
          </NavLink>
        ))}
        <a href="https://portal.informat.ie/" onClick={() => setOpen(false)}>
          Client Portal
        </a>
        <NavLink to="/contact" onClick={() => setOpen(false)}>
          Discuss a project
        </NavLink>
      </nav>
    </header>
  )
}
